module.exports = __webpack_public_path__ + "static/media/Cairo-ExtraLight.e34bbdb4.woff";